import { ReactElement } from 'react'
import Entity from '../../../Entity/EntityList'
import { useSearchParams } from 'react-router-dom'
import {
    Applications,
    FMTABS,
    TAB_PAGE_VIEW,
    URLSearchParamsKeys,
} from '../../../../constants/constants'
import ViewEntity from '../../../ViewEntity'

interface IReports {
    scheduledReportsEntityTemplateId: string
}
const Reports = (props: IReports): ReactElement => {
    const { scheduledReportsEntityTemplateId } = props
    const [searchParams] = useSearchParams()
    const tabPageView =
        searchParams.get(URLSearchParamsKeys.pageView) ||
        TAB_PAGE_VIEW.LIST_VIEW
    const isReportsListView = TAB_PAGE_VIEW.LIST_VIEW === tabPageView
    return isReportsListView ? (
        <Entity
            tabIndex={FMTABS.REPORTS}
            applicationId={Applications.facilityMonitoring.id}
            templateId={scheduledReportsEntityTemplateId}
        />
    ) : (
        <ViewEntity />
    )
}

export default Reports
